/**
 * 모달, 바텀시트처럼 화면 위에 무언가가 떠 있는 동안 배경 스크롤을 막고 싶을 때 쓴다.
 * isOpen이 true인 동안 html/body에 scroll-lock 클래스를 붙였다가, 닫히거나 언마운트되면 뗀다.
 *
 * ★ 파일명(useScollLock)에 오타가 있다(Scoll → Scroll이어야 함). 이미 여러 화면에서
 *   이 파일명 그대로 import하고 있어 지금 고치면 그 화면들이 전부 깨진다. 그래서 고치지 않고 둔다.
 */
import { useSafeLayoutEffect } from './useSafeLayoutEffect';

const CLASSNAME = 'scroll-lock';

export const useScrollLock = (isOpen: boolean) => {
  useSafeLayoutEffect(() => {
    if (isOpen) {
      document.documentElement.classList.add(CLASSNAME);
      document.body.classList.add(CLASSNAME);
    } else {
      document.documentElement.classList.remove(CLASSNAME);
      document.body.classList.remove(CLASSNAME);
    }
    return () => {
      document.documentElement.classList.remove(CLASSNAME);
      document.body.classList.remove(CLASSNAME);
    };
  }, [isOpen]);
};
